const CardBox = ({ children, style = {} }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        padding: 24,
        border: "1px solid #E4E7EE",
        backgroundColor: "#FFFFFF",
        boxShadow:
          "0px 0px 1px 0px #0000001F, 0px 4px 16px -4px #00000014",
        borderRadius: 16,
        boxSizing: "border-box",
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default CardBox;
